import { RootMutations } from "./types";
import {
  VUEX_LOCALSTORAGE_KEYS,
  VUEX_PERSISTENT_LOCALSTORAGE_KEYS,
  VUEX_ROOT_MUTATION_NAMES
} from "@tt-app/constants";
import { UserState } from "@tt-app/store/user/types";

const {
  ANDROID_APP_VERSION,
  APP_VERSION_ALERT,
  BOOKMARKED_COURSE_LIMIT_MULTIPLIER,
  COURSE_EXPLORE_SEARCH_STRING,
  COURSE_EXPLORE_SELECTED_CATEGORY_IDS,
  COURSE_EXPLORE_SELECTED_EXAM_INDEX,
  COURSE_EXPLORE_SELECTED_LEVEL_INDEXES,
  DEVICE_UUID,
  GROUP_COURSE_LIMIT_MULTIPLIER,
  GROUP_COURSE_SELECTED_CATEGORY_IDS,
  GROUP_COURSE_SELECTED_EXAM_INDEX,
  GROUP_COURSE_SELECTED_GROUP_INDEX,
  GROUP_COURSE_SELECTED_LEVEL_INDEXES,
  IOS_APP_VERSION,
  LEARNING_HISTORY_END_DATE,
  LEARNING_HISTORY_START_DATE,
  LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL,
  MAINTENANCE_MODE,
  NOTIFICATION_TOASTS,
  ONE_SIGNAL_CTA_INTERACTION,
  ONE_SIGNAL_INITIALIZED,
  ONE_SIGNAL_NOTIFICATION_PERMISSION,
  OPENED_CHAPTERS,
  PREVIOUS_ROUTE,
  SELECTED_SKILL_LEVEL_INDEXES
} = VUEX_ROOT_MUTATION_NAMES;

export const rootMutations: RootMutations = {
  [ANDROID_APP_VERSION](state, payload) {
    state.androidAppVersion = payload.androidAppVersion;
  },

  [APP_VERSION_ALERT](state, payload) {
    state.appVersionAlert = payload;
  },

  assignmentDetailsEntryRoute(state, entryRoute) {
    state.navigation.assignmentDetails.entryRoute = entryRoute;
  },

  [BOOKMARKED_COURSE_LIMIT_MULTIPLIER](state, limitMultiplier) {
    state.course.bookmarked.limitMultiplier = limitMultiplier;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.BOOKMARKED_COURSE_LIMIT_MULTIPLIER,
      limitMultiplier
    );
  },
  [COURSE_EXPLORE_SEARCH_STRING](state, searchString) {
    state.course.explore.searchString = searchString;

    localStorage.setItem(VUEX_LOCALSTORAGE_KEYS.COURSE_EXPLORE_SEARCH_STRING, searchString);
  },
  [COURSE_EXPLORE_SELECTED_CATEGORY_IDS](state, selectedCategoryIds) {
    state.course.explore.selectedCategoryIds = selectedCategoryIds;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.COURSE_EXPLORE_SELECTED_CATEGORY_IDS,
      JSON.stringify(selectedCategoryIds)
    );
  },
  [COURSE_EXPLORE_SELECTED_EXAM_INDEX](state, selectedExamIndex) {
    state.course.explore.selectedExamIndex = selectedExamIndex;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.COURSE_EXPLORE_SELECTED_EXAM_INDEX,
      selectedExamIndex
    );
  },
  [COURSE_EXPLORE_SELECTED_LEVEL_INDEXES](state, selectedLevelIndexes) {
    state.course.explore.selectedLevelIndexes = selectedLevelIndexes;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.COURSE_EXPLORE_SELECTED_LEVEL_INDEXES,
      JSON.stringify(selectedLevelIndexes)
    );
  },
  [DEVICE_UUID](state, deviceUuid) {
    state.deviceUuid = deviceUuid;

    localStorage.setItem(VUEX_PERSISTENT_LOCALSTORAGE_KEYS.DEVICE_UUID, deviceUuid);
  },
  [GROUP_COURSE_LIMIT_MULTIPLIER](state, limitMultiplier) {
    state.course.group.limitMultiplier = limitMultiplier;

    localStorage.setItem(VUEX_LOCALSTORAGE_KEYS.GROUP_COURSE_LIMIT_MULTIPLIER, limitMultiplier);
  },
  [GROUP_COURSE_SELECTED_CATEGORY_IDS](state, selectedCategoryIds) {
    state.course.group.selectedCategoryIds = selectedCategoryIds;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.GROUP_COURSE_SELECTED_CATEGORY_IDS,
      JSON.stringify(selectedCategoryIds)
    );
  },
  [GROUP_COURSE_SELECTED_EXAM_INDEX](state, selectedExamIndex) {
    state.course.group.selectedExamIndex = selectedExamIndex;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.GROUP_COURSE_SELECTED_EXAM_INDEX,
      selectedExamIndex
    );
  },
  [GROUP_COURSE_SELECTED_LEVEL_INDEXES](state, selectedLevelIndexes) {
    state.course.group.selectedLevelIndexes = selectedLevelIndexes;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.GROUP_COURSE_SELECTED_LEVEL_INDEXES,
      JSON.stringify(selectedLevelIndexes)
    );
  },
  [GROUP_COURSE_SELECTED_GROUP_INDEX](state, selectedGroupIndex) {
    state.course.group.selectedGroupIndex = selectedGroupIndex;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.GROUP_COURSE_SELECTED_GROUP_INDEX,
      selectedGroupIndex
    );
  },

  [IOS_APP_VERSION](state, payload) {
    state.iosAppVersion = payload.appVersion;
  },

  [NOTIFICATION_TOASTS](state, notificationToasts) {
    state.notificationToasts = notificationToasts;
  },

  [ONE_SIGNAL_INITIALIZED](state: any) {
    state.oneSignal.initialized = true;
  },

  [ONE_SIGNAL_CTA_INTERACTION](state: any, payload: any) {
    state.oneSignal.ctaInteraction = payload.status;

    const ctaInteractionLogString =
      localStorage.getItem(VUEX_PERSISTENT_LOCALSTORAGE_KEYS.CTA_INTERACTION) || "{}";

    const ctaInteractionLog = JSON.parse(ctaInteractionLogString);

    const newInteractionLog = {
      ...ctaInteractionLog,
      [payload.userUuid]: payload.status
    };

    localStorage.setItem(
      VUEX_PERSISTENT_LOCALSTORAGE_KEYS.CTA_INTERACTION,
      JSON.stringify(newInteractionLog)
    );
  },

  [ONE_SIGNAL_NOTIFICATION_PERMISSION](state: any, permission: any) {
    state.oneSignal.notificationPermission = permission;
  },

  [OPENED_CHAPTERS](state, openedChapters) {
    state.course.openedChapters = openedChapters;

    localStorage.setItem(
      VUEX_PERSISTENT_LOCALSTORAGE_KEYS.OPENED_CHAPTERS,
      JSON.stringify(state.course.openedChapters)
    );
  },
  [LEARNING_HISTORY_END_DATE](state, endDate) {
    state.historyInputs.endDate = endDate;

    localStorage.setItem(VUEX_LOCALSTORAGE_KEYS.LEARNING_HISTORY_END_DATE, endDate.toString());
  },
  [LEARNING_HISTORY_START_DATE](state, startDate) {
    state.historyInputs.startDate = startDate;

    localStorage.setItem(VUEX_LOCALSTORAGE_KEYS.LEARNING_HISTORY_START_DATE, startDate.toString());
  },
  [MAINTENANCE_MODE](state, value: { active: boolean; message: string }) {
    state.maintenanceMode.active = Boolean(value.active);
    state.maintenanceMode.message = value.message;
  },
  courseDetailsEntryRoute(state, entryRoute) {
    state.navigation.courseDetails.entryRoute = entryRoute;
  },
  [PREVIOUS_ROUTE]: (state, prevPath) => {
    state.navigation.prevPath = prevPath;
  },
  [LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL](state, exerciseTypeAndSkill) {
    state.historyInputs.selectedExerciseTypeAndSkill = exerciseTypeAndSkill;

    localStorage.setItem(
      VUEX_LOCALSTORAGE_KEYS.LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL,
      exerciseTypeAndSkill
    );
  },
  [SELECTED_SKILL_LEVEL_INDEXES](state, payload) {
    const userUuid = ((state as any).user as UserState).profile?.userUuid || "";

    const newObject = {
      ...state.skills.selectedSkillLevelIndexes,
      [userUuid]: payload
    };

    state.skills.selectedSkillLevelIndexes = newObject;

    localStorage.setItem(
      VUEX_PERSISTENT_LOCALSTORAGE_KEYS.SELECTED_SKILL_LEVEL_INDEXES,
      JSON.stringify(newObject)
    );
  }
};
